import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  subtitle: string;
  dark?: boolean;
};

export function ChatEmptyState({ title, subtitle, dark }: Props) {
  const textColor = dark ? 'gray.3' : 'gray.7';

  return (
    <Flex direction="column" align="center" justify="center" h="100%" px="xl">
      <Text size="textXl" fw={FONT_WEIGHTS.semibold} c={textColor} ta="center">
        {title}
      </Text>
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c={textColor} ta="center" mt="xxs">
        {subtitle}
      </Text>
    </Flex>
  );
}
